import React, { useContext, useEffect, useState } from 'react';
import { Modal } from 'antd';
import styled from 'styled-components';

import { MerchantsContext } from '../../contexts/MerchantsContext';

const StyledBold = styled.span`
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  line-height: 22px;
`;

const DeleteMerchant = props => {
  const { deleteMerchant, response, setResponse } = useContext(
    MerchantsContext
  );
  const { modalVisible, setModalVisible, modal, selectedMerchant } = props;
  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    setModalVisible(false);
  };

  const handleOk = () => {
    setLoading(true);
    deleteMerchant(selectedMerchant.id);
  };

  const handleCancel = () => {
    setResponse({});
    setLoading(false);
    closeModal();
  };

  useEffect(() => {
    if (Object.entries(response).length !== 0 && !response.errors) {
      closeModal();
    }

    if (Object.entries(response).length !== 0) {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);

  if (modal === 'delete') {
    return (
      <Modal
        title={`Delete ${selectedMerchant.name}`}
        visible={modalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        confirmLoading={loading}
      >
        <p>
          This operation will permanently delete{' '}
          <StyledBold>
            {selectedMerchant.name ? selectedMerchant.name.toUpperCase() : null}
          </StyledBold>
          !
        </p>
        <p>Are you sure you want to continue?</p>
      </Modal>
    );
  } else {
    return null;
  }
};

export default DeleteMerchant;
